// extracted by mini-css-extract-plugin
module.exports = {"nav":"Navigation_nav__wajNd"};